import { FC, ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import theme from 'styles/theme'

// Field label styled per the "Panel Klienta 3.0" form design.
export const FieldLabel: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography
    sx={{ fontSize: '13px', fontWeight: 600, color: theme.r4r.navy, mb: '6px', mt: '20px' }}>
    {children}
  </Typography>
)

// Step indicator: dashes + "Krok X z Y — label" caption.
export const StepIndicator: FC<{ step: number; totalSteps: number; label: string }> = ({
  step,
  totalSteps,
  label
}) => (
  <Box sx={{ pt: '14px', pb: '4px' }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: '6px', mb: '6px' }}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <Box
          key={i}
          sx={{
            width: '32px',
            height: '4px',
            backgroundColor: i <= step ? theme.r4r.navy : theme.r4r.greyLight
          }}
        />
      ))}
    </Box>
    <Typography sx={{ fontSize: '12px', color: theme.r4r.grey, textAlign: 'center' }}>
      {label}
    </Typography>
  </Box>
)

// Solid navy action button ("Dalej").
export const primaryButtonSx = {
  backgroundColor: theme.r4r.navy,
  color: '#fff',
  fontSize: '14px',
  fontWeight: 700,
  borderRadius: 0,
  padding: '12px 20px',
  boxShadow: 'none',
  ':hover': {
    backgroundColor: theme.r4r.ink,
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.r4r.greyLight,
    color: theme.r4r.grey
  }
} as const

// Yellow submit button ("Wyślij zgłoszenie" / "Zarezerwuj").
export const submitButtonSx = {
  backgroundColor: theme.r4r.yellow,
  color: theme.r4r.navy,
  fontSize: '14px',
  fontWeight: 700,
  borderRadius: 0,
  padding: '12px 20px',
  boxShadow: 'none',
  ':hover': {
    backgroundColor: '#E5B500',
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.r4r.greyLight,
    color: theme.r4r.grey
  }
} as const

// Chip-style selectable option (time slots, durations).
export const optionChipSx = (isSelected: boolean, isDisabled = false) =>
  ({
    padding: '8px 0',
    fontSize: '13px',
    fontWeight: isSelected ? 700 : 500,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: isSelected ? theme.r4r.navy : '#fff',
    color: isSelected ? '#fff' : isDisabled ? theme.r4r.greyLight : theme.r4r.azure,
    border: `1px solid ${isSelected ? theme.r4r.navy : theme.r4r.greyLight}`
  } as const)

// White card holding an inline DateCalendar.
export const calendarCardSx = {
  backgroundColor: '#fff',
  boxShadow: theme.r4r.cardShadow
} as const

export const calendarSx = {
  width: '100%',
  '.MuiPickersDay-root.Mui-selected': {
    backgroundColor: `${theme.r4r.navy} !important`,
    borderRadius: 0
  }
} as const
